<script setup lang="ts">
import { computed, defineProps, withDefaults, defineEmits } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';

interface Props {
    modelValue: number;
    transferInfo?: OperationInfo;
    performOperation: () => void;
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: 0,
    transferInfo: undefined
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: number): void
}>();

const actionText = computed(() => {
    const actions = props.transferInfo?.action.upper;
    return actions ? actions[actions.length - 1] : 'Transfer';
});

const placeholderText = computed(() =>
    `${actionText.value} amount`
);

const isDisabled = computed(() => props.modelValue === 0);
</script>

<template>
    <div>
        <!-- Amount Input -->
        <input type="number" :value="modelValue"
            @input="emit('update:modelValue', +($event.target as HTMLInputElement).value)"
            class="border border-primary text-center text-xl w-full p-2 rounded mb-2" :placeholder="placeholderText" />

        <!-- Action Button -->
        <button @click="performOperation"
            class="w-full text-xl rounded bg-primary px-4 py-2 text-white border border-white" :disabled="isDisabled">
            {{ actionText }} fish
        </button>
    </div>
</template>